<template>
  <button class="back-to-top goTop" v-scroll="handleScroll" @click="backToTop">
    <img src="/img/up-arrow.svg">
  </button>
</template>

<script>
export default {
  data: function() {
    return {
      isVisible: false
    };
  },
  methods: {
    backToTop() {
      window.scrollTo(0, 0);
    },
    handleScroll(evt, el) {
      if (window.scrollY > 250) {
        el.setAttribute("style", "opacity: 1; z-index: 100");
      } else {
        el.setAttribute("style", "opacity: 0; z-index: -1");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.back-to-top {
  border-radius: 5px;
  background-color: #c20365;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
  position: fixed;
  width: 45px;
  height: 45px;
  display: block;
  right: 15px;
  bottom: 15px;
  border: none;
  opacity: 0;
  z-index: -1;
  font-size: 26px;
  color: #fff;
  cursor: pointer;
  text-align: center;
  padding: 0;
  img{
    width: 20px;
  }
  &:active,
  &:focus {
    outline: none;
  }
}
</style>
